export default "__VITE_ASSET__DjU$qTdO__"